import { render, staticRenderFns } from "./goodsFullInfo.vue?vue&type=template&id=0fc7181b&scoped=true&"
import script from "./goodsFullInfo.vue?vue&type=script&lang=js&"
export * from "./goodsFullInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsFullInfo.vue?vue&type=style&index=0&id=0fc7181b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7181b",
  null
  
)

export default component.exports